import React from 'react';
import { LayoutEditMyProducts } from '../../Layout/EditMyProducts-Layout-Components/LayoutEditMyProducts';


export const EditProductsPage = () => {
  return (
    <LayoutEditMyProducts/>
  )
}
